export default "__VITE_ASSET__CxYsKy2$__"